const defaultValues = {
  files: {},
  addFile: (file, property = "") => {},
};
Object.freeze(defaultValues);

export default defaultValues;
